import {
  Box,
  Button,
  FormHelperText,
  InputAdornment,
  Modal,
  OutlinedInput,
  TextField,
} from '@mui/material'
import React, { useState } from 'react'
import CustomButton from '../components/styled/CustomButton'
import CustomInput from '../components/styled/CustomInput.styled'
import SelectAvailableDateModal from './SelectAvailableDateModal'
import SelectLocationModal from './SelectLocationModal'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  //   width: "35%",
  borderRadius: '16px',
  textAlign: 'center',
  maxHeight: '90vh',
  overflow: 'auto',
}

const AddChargesModal = ({
  toggleAddChargesModal,
  modalOpen,
  selectedSubService,
}) => {
  const [selectAvailableDateModal, setSelectAvailableDateModal] = useState(
    false,
  )
  const [center, setCenter] = React.useState({
    lat: 48.8584,
    lng: 2.2945,
  })
  const [mapCenter, setMapCenter] = React.useState({
    ...center,
  })
  const [value, setValue] = React.useState(null)
  const [zipCode, setZipCode] = useState('')
  const [selectedService, setSelectedService] = useState({
    ...selectedSubService,
  })

  const [subServiceCharges, setSubServiceCharges] = useState('')
  const [selectLocationModal, setSelectLocationModal] = useState(false)

  const handleSelectAvailableDateModal = () => {
    if (modalOpen) {
      toggleAddChargesModal(false)
    }
    setSelectAvailableDateModal(!selectAvailableDateModal)
  }

  const handleServiceCharges = (e) => {
    e?.preventDefault()
    setSelectedService({
      ...selectedSubService,
      price: Number(subServiceCharges),
    })
    if (modalOpen) {
      toggleAddChargesModal(false)
    }
    handleSelectLocationModal()
    // handleSelectAvailableDateModal()
  }

  const handleSelectLocationModal = () => {
    setSelectLocationModal(!selectLocationModal)
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => toggleAddChargesModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <form onSubmit={handleServiceCharges}>
            <div className="add-charges-modal">
              <h3 className="fs-24">Add Charges</h3>
              <FormHelperText id="input-label" className="mt-3" margin="dense">
                Add Charges
              </FormHelperText>
              <TextField
                id="outlined-adornment-amount"
                placeholder="40"
                type={'number'}
                required
                value={subServiceCharges}
                onChange={(e) => {
                  if (e.target.value > 0) {
                    setSubServiceCharges(e.target.value)
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                  inputProps: { min: 0, style: { marginLeft: '-6px' } },
                }}
                variant="outlined"
              />
              <Button
                disableElevation
                id="btn-primary-no-shadow"
                variant="contained"
                fullWidth={true}
                className="pointer shadow-none mt-3"
                type="submit"
              >
                Next
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
      <SelectAvailableDateModal
        handleSelectAvailableDateModal={handleSelectAvailableDateModal}
        modalOpen={selectAvailableDateModal}
        selectedSubService={selectedService}
        screenName="create-booking"
      />
      <SelectLocationModal
        handleSelectLocationModal={handleSelectLocationModal}
        selectLocationModal={selectLocationModal}
        mapCenter={mapCenter}
        setCenter={setCenter}
        value={value}
        setValue={setValue}
        setZipCode={setZipCode}
        action="open-select-available-date-modal"
        selectedService={{ ...selectedSubService, price: +subServiceCharges }}
      />
    </>
  )
}

export default AddChargesModal
